import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';

export default function ContactManager() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const [contactData, setContactData] = useState({
    address: 'Halkalı Merkez Mah. 1. Çeşme Sok. No: 13/E Küçükçekmece / İstanbul',
    phone: '0 532 500 38 69',
    email: 'info@kareyapıinsaat.com',
    workingHours: 'Pazartesi - Cumartesi: 09:00 - 18:00\nPazar: Kapalı',
    mapIframeUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.2345678901234!2d28.7856789!3d40.9876543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDDCsDU5JzE1LjYiTiAyOMKwNDcnMDguNCJF!5e0!3m2!1str!2str!4v1234567890123!5m2!1str!2str',
    facebook: 'https://www.facebook.com/kareyapiinsaat',
    instagram: 'https://www.instagram.com/kamerun_insaat?igsh=MWFqNTkyMmU3eGRlYg%3D%3D',
    twitter: 'https://twitter.com/kareyapiinsaat',

    youtube: 'https://www.youtube.com/kareyapiinsaat'
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, 'settings', 'contact');
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          const dbData = snap.data();
          dbData.address = 'Halkalı Merkez Mah. 1. Çeşme Sok. No: 13/E Küçükçekmece / İstanbul';
          dbData.instagram = 'https://www.instagram.com/kamerun_insaat?igsh=MWFqNTkyMmU3eGRlYg%3D%3D';
          setContactData({ ...contactData, ...dbData });
        } else {
          // Auto route-seed
          await setDoc(docRef, contactData, { merge: true });
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setContactData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    try {
      await setDoc(doc(db, 'settings', 'contact'), contactData, { merge: true });
      setMessage('İletişim ayarları başarıyla kaydedildi!');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage('Kayıt başarısız oldu.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-zinc-500">Yükleniyor...</div>;

  return (
    <div className="space-y-6 pb-24">
      <div className="mb-6">
        <h2 className="text-2xl font-black text-white uppercase tracking-widest" style={{ fontFamily: 'Raleway, sans-serif' }}>İletişim & Sosyal Medya</h2>
        <p className="text-zinc-400 text-sm mt-1">Sitedeki Footer (alt kısım) ve İletişim sayfasında yer alan firma bilgileri buradan yönetilir.</p>
      </div>

      {message && (
        <div className={`p-4 rounded-xl font-bold text-sm ${message.includes('başarısız') ? 'bg-red-500/10 text-red-500' : 'bg-green-500/10 text-green-500'}`}>
          {message}
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        
        {/* Temel İletişim */}
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 md:p-8 space-y-6">
          <h3 className="text-lg font-bold text-white uppercase tracking-wider mb-4 border-b border-zinc-800 pb-2">Temel İletişim Bilgileri</h3>
          
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider">Açık Adres</label>
            <textarea name="address" value={contactData.address} onChange={handleChange} rows={3} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none"></textarea>
          </div>
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider">Telefon Numarası</label>
            <input type="text" name="phone" value={contactData.phone} onChange={handleChange} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider">E-Posta Adresi</label>
            <input type="email" name="email" value={contactData.email} onChange={handleChange} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider">Çalışma Saatleri</label>
            <textarea name="workingHours" value={contactData.workingHours} onChange={handleChange} rows={2} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none"></textarea>
          </div>
        </motion.div>

        {/* Sosyal Medya */}
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 md:p-8 space-y-6">
          <h3 className="text-lg font-bold text-white uppercase tracking-wider mb-4 border-b border-zinc-800 pb-2">Sosyal Medya Linkleri</h3>
          
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider"><i className="ri-facebook-circle-fill mr-2 text-blue-500"></i> Facebook Linki</label>
            <input type="url" name="facebook" value={contactData.facebook} onChange={handleChange} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider"><i className="ri-instagram-fill mr-2 text-pink-500"></i> Instagram Linki</label>
            <input type="url" name="instagram" value={contactData.instagram} onChange={handleChange} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider"><i className="ri-twitter-x-line mr-2 text-white"></i> X (Twitter) Linki</label>
            <input type="url" name="twitter" value={contactData.twitter} onChange={handleChange} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none" />
          </div>

           <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2 uppercase tracking-wider"><i className="ri-youtube-fill mr-2 text-red-500"></i> Youtube Linki</label>
            <input type="url" name="youtube" value={contactData.youtube} onChange={handleChange} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none" />
          </div>
        </motion.div>

        {/* Harita */}
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6 md:p-8 col-span-1 lg:col-span-2 space-y-6">
          <h3 className="text-lg font-bold text-white uppercase tracking-wider mb-4 border-b border-zinc-800 pb-2">Google Maps Harita Kodu (iFrame URL)</h3>
          <div>
            <label className="block text-zinc-400 text-xs font-bold mb-2">Sadece URL kısmını "https://www.google.com/maps/embed?..." buraya yapıştırın</label>
            <input type="text" name="mapIframeUrl" value={contactData.mapIframeUrl} onChange={handleChange} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none" />
          </div>
          {contactData.mapIframeUrl && (
             <div className="w-full h-48 mt-4 rounded-xl overflow-hidden border border-zinc-800">
                <iframe src={contactData.mapIframeUrl} className="w-full h-full border-0" allowFullScreen loading="lazy"></iframe>
             </div>
          )}
        </motion.div>

      </div>

      <div className="fixed bottom-0 left-0 right-0 md:left-64 bg-zinc-950/80 backdrop-blur-lg border-t border-zinc-800 p-4 flex justify-end z-50">
         <button onClick={handleSave} disabled={saving} className="bg-red-600 hover:bg-red-700 text-white font-black text-lg py-4 px-12 rounded-xl shadow-2xl shadow-red-600/30 transition-all flex items-center gap-3 disabled:opacity-50">
           {saving ? <i className="ri-loader-4-line animate-spin"></i> : <i className="ri-save-3-line"></i>}
           BİLGİLERİ KAYDET
         </button>
      </div>
    </div>
  );
}
